module.exports = __webpack_public_path__ + "static/media/nav-icon3.48882e80.svg";